import { useCallback } from "react";

import useClient from "hooks/useClient";

const useUpdateFilterConditions = () => {
  const { client } = useClient();

  const updateFilterConditions = useCallback(
    async (filterConditions: FilterConditions) => {
      const { status } = await client({
        method: "put",
        url: "/user/filter-conditions",
        data: { filterConditions },
      });
      return status;
    },
    [client]
  );

  return { updateFilterConditions };
};

export default useUpdateFilterConditions;
